// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterPanel_m_F2U {
  width: 300px;
  min-width: auto;
}

button[data-filtered="true"] {
  background: var( --color-brand500 );
  color: var( --color-brand100 );
}

.selected_y3_EP.win__91Ca.really_kbMrR {
  background-color: var( --color-tableSelected ) !important;
}

.rollover_FF8DW.win__91Ca.really_kbMrR {
  background-color: var( --color-tableRollover ) !important;
  cursor: pointer;
}
.selected_y3_EP.rollover_FF8DW.win__91Ca.really_kbMrR {
  background-color: var( --color-tableRolloverSelected ) !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/components/rsrcTable/Shared.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;EACzD,eAAe;AACjB;AACA;EACE,iEAAiE;AACnE","sourcesContent":[".filterPanel {\n  width: 300px;\n  min-width: auto;\n}\n\nbutton[data-filtered=\"true\"] {\n  background: var( --color-brand500 );\n  color: var( --color-brand100 );\n}\n\n.selected.win.really {\n  background-color: var( --color-tableSelected ) !important;\n}\n\n.rollover.win.really {\n  background-color: var( --color-tableRollover ) !important;\n  cursor: pointer;\n}\n.selected.rollover.win.really {\n  background-color: var( --color-tableRolloverSelected ) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterPanel": `filterPanel_m_F2U`,
	"selected": `selected_y3_EP`,
	"win": `win__91Ca`,
	"really": `really_kbMrR`,
	"rollover": `rollover_FF8DW`
};
export default ___CSS_LOADER_EXPORT___;
